import type { MovimentoRecord } from "@/lib/movimento";
import { movimentoTipoBadge } from "@/lib/movimentoUi";
import { cn } from "@/lib/utils";

export function MovimentoTipoBadge({ movimento }: { movimento: MovimentoRecord }) {
  const b = movimentoTipoBadge(movimento);
  return (
    <span
      title={b.title}
      className={cn(
        "inline-flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold",
        b.className,
      )}
    >
      {b.letter}
    </span>
  );
}
